import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';

/**
 * Reusable accordion-style section chrome for BrightNav tab content
 * (Finances, future tabs). Feature owns body and actions via content projection.
 */
@Component({
  selector: 'bn-collapsible-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './collapsible-section.component.html',
  styleUrl: './collapsible-section.component.scss',
})
export class CollapsibleSectionComponent {
  /** Section heading. */
  readonly title = input.required<string>();

  /** Optional PrimeIcons class (e.g. `pi pi-chart-pie`). */
  readonly icon = input<string | null>(null);

  /** Accessible name for the section; defaults to title. */
  readonly ariaLabel = input<string | null>(null);

  /** Whether the body is shown. Two-way bindable. */
  readonly expanded = model(true);

  readonly resolvedAriaLabel = computed(() => this.ariaLabel()?.trim() || this.title());

  toggleExpanded(): void {
    this.expanded.update((v) => !v);
  }
}
